import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import InputFile from "../../Elements/Form/InputFile";
import Button from "../../Elements/Button";
import useQuery from "../../../hook/useQuery";
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory} from "react-router-dom";
import {IProfileUserData} from "../../../contracts/data/user";
import InputSelect from "../../Elements/Form/InputSelect";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import {EducationType, GenderType, IncomeType, priceType} from "../../../constans/enumTypes";


const InnerProfileUserForm = (props: FormikProps<IProfileUserData>) => {
    const queryParams = useQuery()
    const history = useHistory()
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)
    const optionsGender:Array<ISelectOptionsItem> = [
        {value: GenderType.MALE, label:'مرد'},
        {value: GenderType.FEMALE, label:'زن'},
    ]
    const optionsIncome:Array<ISelectOptionsItem> = [
        {value: IncomeType.LOW_INCOME, label:'0 - 3,000,000 تومان'},
        {value: IncomeType.MEDIUM_INCOME, label:'4,000,000 تومان - 7,000,000 تومان'},
        {value: IncomeType.HIGH_INCOME, label:'8,000,000 تومان - 15,000,000 تومان'},
        {value: IncomeType.MAX_HIGH_INCOME, label:'16,000,000 تومان - به بالا'},
    ]
    const optionsEducation:Array<ISelectOptionsItem> = [
        {value: EducationType.NONE, label:'هیچکدام'},
        {value: EducationType.DIPLOMA, label:'دیپلم'},
        {value: EducationType.BACHELOR, label:'کارشناسی'},
        {value: EducationType.MASTER, label:'کارشناسی ارشد'},
        {value: EducationType.PHD, label:'دکتری'},
    ]

    const handleFetchPrevData = async () => {
        await httpClient().get(`${usersApi.profile}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200){
                    props.setValues({
                        id: response?.data?.id,
                        first_name: response?.data?.first_name,
                        last_name: response?.data?.last_name,
                        email: response?.data?.email,
                        avatar: response?.data?.avatar,
                        avatar_url: response?.data?.avatar_url,
                        job: response?.data?.job,
                        gender: response?.data?.gender,
                        income: response?.data?.income,
                        education: response?.data?.education,
                        address: response?.data?.address,
                        state: response?.data?.state,
                        birth_date_jalali: response?.data?.birth_date_jalali,
                    })
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        handleFetchPrevData()
    }, [])

    useEffect(() => {
        if(props.status.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
            if(props.status?.result?.status === 'success'){
                history.replace('/dashboard/users/list')
            }
        }
    }, [props.status])

    return (
        <React.Fragment>
            {loading ? <Loading />:
                <Form>
                <div className={"w-3/5"}>
                    <Input name={"first_name"} label={"نام"} placeholder={"نام..."} isRequired
                           meta={props.getFieldMeta('first_name')} defaultValue={props.values?.first_name}/>
                    <Input name={"last_name"} label={"نام خانوادگی"} placeholder={"نام خانوادگی"} isRequired
                           meta={props.getFieldMeta('last_name')} defaultValue={props.values?.last_name}/>
                    <Input name={"email"} type={"email"} label={"ایمیل"} placeholder={"ایمیل"}
                           meta={props.getFieldMeta('email')} defaultValue={props.values?.email}/>
                    <Input name={"job"} label={"شغل"} placeholder={"شغل"}
                           meta={props.getFieldMeta('job')} defaultValue={props.values?.job}/>
                    <Input name={"birth_date_jalali"} label={"تاریخ تولد"} placeholder={"1401-10-10"}
                           meta={props.getFieldMeta('birth_date_jalali')} defaultValue={props.values?.birth_date_jalali}/>
                    <InputSelect name={'income'} label={'میزان درآمد'}
                                 placeholder={'میزان درآمد...'}
                                 handleSetValue={(values: any) => props.setFieldValue('income', values)}
                                 options={optionsIncome} isMultiple={false} error={props?.errors?.income} // props?.errors?.type!
                                 meta={props.getFieldMeta('income')}
                                 defaultValue={optionsIncome.find((item, _) => item.value === props?.values?.income)}
                                 isClearable
                    />
                    <InputSelect name={'education'} label={'تحصیلات'}
                                 placeholder={'تحصیلات...'}
                                 handleSetValue={(values: any) => props.setFieldValue('education', values)}
                                 options={optionsEducation} isMultiple={false} error={props?.errors?.education} // props?.errors?.type!
                                 meta={props.getFieldMeta('education')}
                                 defaultValue={optionsEducation.find((item, _) => item.value === props?.values?.education)}
                                 isClearable
                    />
                    <InputSelect name={'gender'} label={'جنسیت'}
                                 placeholder={'جنسیت...'}
                                 handleSetValue={(values: any) => props.setFieldValue('gender', values)}
                                 options={optionsGender} isMultiple={false} error={props?.errors?.gender} // props?.errors?.type!
                                 meta={props.getFieldMeta('gender')}
                                 defaultValue={optionsGender.find((item, _) => item.value === props?.values?.gender)}
                                 isClearable
                    />
                    <Input name={"address"} label={"آدرس"} placeholder={"آدرس پستی..."}
                           meta={props.getFieldMeta('address')} defaultValue={props.values?.address}/>
                    <InputFile name={"avatar"} accept={".jpg,.png,.gif"} label={"عکس کاربر"}
                               meta={props.getFieldMeta('avatar')} isImg handleUploadFile={props.setFieldValue}
                               defaultValue={props.values?.avatar}
                    />
                </div>
                <div className={"text-left"}>
                    <Button title={"بروزرسانی پروفایل"} isLoading={props.isSubmitting}/>
                </div>
            </Form>}
        </React.Fragment>
    )
}

export default InnerProfileUserForm